export default __webpack_public_path__ + "static/media/ico-profile.cab1f6a1.png";